import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
// import Postlist from "./component/Postlist";
// import Post from "./component/Post";
import Welcome from "./component/Home/Welcome";
import Trip from "./component/Trip";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" component={Welcome} exact />
        {/* <Route path="/post/:id" component={Post} />
        <Route path="/post" component={Postlist} /> */}
        <Route path="/trip" component={Trip} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
